module.exports = __webpack_public_path__ + "static/img/icon6-12.6862e66a.png";